/**
 * GraphQL error messages
 */
export const errorMsgs = {
  cannotReturnNull:
    'Cannot return null for non-nullable field Query.getTransactionByHash.'
};
